import GENERATE_OR_SCALE from '../GenerateOrScaleUp/langs'
import UPLOAD_FORM from '../UploadForm/langs'
export default {
    GENERATE_OR_SCALE:GENERATE_OR_SCALE.US,
    UPLOAD_FORM:UPLOAD_FORM.US
}